import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnChannel } from '../../../models';
import { SnMembersService } from '../../../services/members.service';

export interface ISnInviteUsersData {
  sid: string;
  members: any[];
}

@Component({
  templateUrl: './invite-users.dialog.html',
})
export class SnInviteUsersDialogComponent implements OnInit, OnDestroy {
  public isLoading = false;
  public memberIds: string[];
  public formErrors;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ISnInviteUsersData,
    private readonly _dialogRef: MatDialogRef<SnInviteUsersDialogComponent>,
    private readonly _membersService: SnMembersService,
  ) {}

  public ngOnInit(): void {
    this.memberIds = this.data.members.map((member) => member.id);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public onFormSent(formData: any): void {
    this.isLoading = true;

    if (formData.users?.length) {
      this.memberIds.push(...formData.users);

      this._membersService
        .inviteUser(this.data.sid, formData.users)
        .pipe(
          takeUntil(this._destroy$),
          finalize(() => (this.isLoading = false)),
        )
        .subscribe((channel: SnChannel) => {
          this._dialogRef.close(channel);
        });
    } else {
      this._membersService
        .inviteExtUser(this.data.sid, formData)
        .pipe(
          takeUntil(this._destroy$),
          finalize(() => (this.isLoading = false)),
        )
        .subscribe({
          next: (channel: SnChannel) => {
            this._dialogRef.close(channel);
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 400) {
              this.formErrors = err.error;
            }
          },
        });
    }
  }
}
